import { render, staticRenderFns } from "./PatientAccountStatement.vue?vue&type=template&id=2d44b134&scoped=true"
import script from "./PatientAccountStatement.vue?vue&type=script&lang=js"
export * from "./PatientAccountStatement.vue?vue&type=script&lang=js"
import style0 from "./PatientAccountStatement.vue?vue&type=style&index=0&id=2d44b134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44b134",
  null
  
)

export default component.exports